module.exports = __webpack_public_path__ + "img/reset-jobmule.bcc0c7a1.png";